import { IoCall, IoMail, IoHourglass } from "react-icons/io5";

export const contactActionsData = [
    {
        id: 1,
        icon: <IoCall />,
        title: "Call:",
        info: "+1 5524 5588 55"
    },
    {
        id: 2,
        icon: <IoMail />,
        title: "Email:",
        info: "help@consultx.com"
    },
    {
        id: 3,
        icon: <IoHourglass />,
        title: "Working Hours:",
        info: "9:00AM To 6:00PM"
    },
];